// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeRedactedUserBasic --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiRedactedUserBasicObjectFieldType,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeRedactedUserBasicFragment on OpenapiRedactedUserBasic {
    email
    id
    name
    object
    password_set
  }
`;

export const stripeRedactedUserBasicFragment: StripeRedactedUserBasicFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeRedactedUserBasicFragmentData = {
  readonly __typename: 'OpenapiRedactedUserBasic';
  readonly email: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly object: OpenapiRedactedUserBasicObjectFieldType;
  readonly password_set: boolean | null;
};

export type StripeRedactedUserBasicFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeRedactedUserBasicFragmentPermissions = {} as const;

doc.permissions = stripeRedactedUserBasicFragmentPermissions;

export type StripeRedactedUserBasicFragmentPermissions = V1PermissionToken<
  typeof stripeRedactedUserBasicFragmentPermissions
>;

export type StripeRedactedUserBasicFragmentDocument = GraphQlDocument<
  StripeRedactedUserBasicFragmentData,
  StripeRedactedUserBasicFragmentVariables,
  StripeRedactedUserBasicFragmentPermissions
>;
